import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  NbComponentStatus,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";

import { CatalogService } from "../../services/catalog.service";

import { UserService } from "../../@core/services/user.service";
import { User } from "../../@core/data/users";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import { DialogYesNoPromptComponent } from "../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { Catalog } from "../../models/product.model";
import * as _ from "lodash";

@Component({
  selector: "ngx-view-catalogs",
  styleUrls: ["./view-catalogs.component.scss"],
  templateUrl: "./view-catalogs.component.html",
})
export class ViewCatalogsComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string = "";
  @Input() mode?: string = "units"; //catalog.mode
  @Input() catalogs?: Catalog[] = [];

  loading = false;
  submitted = false;
  isEditing = false;

  strSearch = "";
  uid = "anonymous";

  constructor(
    private userService: UserService,
    private catalogService: CatalogService,
    private router: Router,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;

          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }
        } else {
          this.uid = "anonymous";
        }
      });

    console.log("ngOnInit:", this.catalogs);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  //Create
  create() {
    let cat = new Catalog();
    cat.title = this.strSearch.trim();
    cat.mode = this.mode;
    if (cat.title.length > 0) {
      this.loading = true;
      this.submitted = true;

      this.catalogService
        .create(cat)
        .then((data) => {
          // this.catalogs.push(data);

          this.strSearch = "";
          this.loading = false;
          this.submitted = false;
        })
        .catch((err) => {
          this.loading = false;
          this.submitted = false;
        });
    }
  }

  //Edit
  title = "";
  onEdit(item: Catalog) {
    item.editing = true;
    this.title = item.title;
    this.isEditing = true;
  }
  cancelEdit(item: Catalog) {
    item.editing = false;
    this.isEditing = false;
  }
  confirmEdit(item: Catalog) {
    item.loading = true;
    item.title = this.title;

    this.catalogService
      .update(item)
      .then((data) => {
        this.title = "";
        item.editing = false;
        item.loading = false;
        this.isEditing = false;
      })
      .catch((err) => {
        item.loading = false;
      });
  }

  //Delete
  delete(item) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nội dung này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.catalogService
            .delete(this.shopId, item.id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }
}
